<template>
  <div class="SliderVideo">

    <div class="SliderVideo-controls">

      <div class="SliderVideo-button"
        @click="togglePlay">

        <icon
          v-if="isPlaying"
          class="SliderVideo-pause"
          name="pause" 
          width="42px" 
          height="45px" />

        <icon
          v-if="!isPlaying"
          class="SliderVideo-play"
          name="play" 
          width="17.42px" 
          height="19.85px" />

        <svg 
          class="SliderVideo-progress"
          width="80px"
          height="80px">

          <circle
            class="SliderVideo-progressCircle"
            r="36"
            cx="40"
            cy="40"
            :stroke-dasharray="dasharray"
            :stroke-dashoffset="dashoffset" />

        </svg>

      </div>

    </div>
    
    <player class="SliderVideo-video"
      ref="player"
      :options="options"
      @timeupdate="handleTimeupdate"
      @play="handlePlay"
      @pause="handlePause"
      @ended="handleEnded" />

  </div>
</template>

<script>
import { videoPlayer as Player } from 'vue-video-player'

import Icon from 'components/Icon'

export default {
  name: 'SliderVideo',

  components: {
    Icon,
    Player
  },

  props: {
    url: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      options: {
        width: 930,
        height: 930,
        loop: false,
        controls: false
      },
      progressPercentage: 0,
      isPlaying: false
    }
  },

  computed: {
    player () {
      return this.$refs.player.player
    },

    duration () {
      return this.player.duration()
    },

    circumference () {
      return 36 * 2 * Math.PI
    },

    dasharray () {
      return `${this.circumference} ${this.circumference}`
    },

    dashoffset () {
      return this.circumference - this.progressPercentage / 100 * this.circumference
    }
  },

  watch: {
    selected () {
      if (this.selected) {
        this.player.play()
      } else {
        setTimeout(() => {
          this.player.pause()
          this.player.currentTime(0)
        }, 1000)
      }
    }
  },

  mounted () {
    this.$nextTick(this.init)
  },

  methods: {
    init () {
      this.player.src(this.url)
      this.player.volume(0.8)
    },

    handleTimeupdate () {
      this.progressPercentage = Math.min(100, ((100 / this.duration) * this.player.currentTime())) || 0
    },

    handlePlay () {
      this.isPlaying = true
    },

    handlePause () {
      this.isPlaying = false
    },

    handleEnded () {},

    togglePlay () {
      this.isPlaying ? this.player.pause() : this.player.play()
    }
  }
}
</script>

<style>
@import '~video.js/dist/video-js.css';

.SliderVideo {
}

.SliderVideo-controls {
  position: absolute;
  z-index: 9000;
  right: 0;
  bottom: 95px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
}

.SliderVideo-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: var(--color-1);
  border: 2px solid var(--color-3);
}

.SliderVideo-pause,
.SliderVideo-play {
  position: relative;
  z-index: 1;
  fill: var(--color-3)
}

.SliderVideo-play {
  position: relative;
  left: 2px;
}

.SliderVideo-progress {
  position: absolute;
  z-index: -1;
}

.SliderVideo-progressCircle {
  stroke: var(--color-3);
  stroke-width: 8px;
  transition: stroke-dashoffset 0.35s;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
  fill: transparent;
}

.SliderVideo-video {
}

.SliderVideo-video video {
  background: linear-gradient(to bottom, #fff 0%, 74.38%, #808081 100%);
}
</style>



// WEBPACK FOOTER //
// Video.vue?04bc09de